<div class="c-modal-header">
  <h2 class="c-modal-title">Bid Results</h2>
  <button class="c-modal-close" (click)="closeModal()"></button>
</div>

<muni-shared-mini-card-header
        *ngIf="context.deal"
        [deal]="context.deal"
        [isModal]="true"
        class="gameday-mini-card__header">
</muni-shared-mini-card-header>

<div
  [attr.data-automation-e2e-selector]="'muni-bid-results-modal'"
  class="muni-bid-results-modal-body"
>
  <div class="c-d-flex c-flex-column" *ngIf="bidResults$ | async as bidResults">
    <table class="c-table">
      <thead>
        <tr>
          <th>Dealer Name</th>
          <th *ngIf="hasParColumn$ | async" class="c-text-right" width="110">
            Par
          </th>
          <th class="c-text-right" width="110">{{ bidResults.bidType }} (%)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bid of bidResults?.bids">
          <td class="c-d-flex c-justify-space-between">
            <span>
              {{ bid.shortName || bid.name }}
            </span>
            <!-- <span
              *ngIf="
                bid.winningBid ||
                (bid.orionId && (winningOrionId$ | async) === bid.orionId)
              "
              class="c-pull-right c-badge c-badge-secondary dealer-badge dealer-badge-lime"
              >High</span
            > -->
          </td>
          <td *ngIf="hasParColumn$ | async" class="c-text-right">
            {{ bid.parAmount | number: '1.0' }}
          </td>
          <td class="c-text-right">{{ bid.bidAmount | number: '1.6' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
